import { SxProps, Theme, Typography } from "@mui/material";
import { useFormat } from "@myplant-io/utils/localization";

type Props = {
  date: string;
  variant?: "caption" | "body2";
  color?: string;
  noWrap?: boolean;
  sx?: SxProps<Theme>;
};

export const Timestamp = ({
  date,
  variant = "caption",
  color = "textSecondary",
  noWrap,
  sx,
}: Props) => {
  const { formatDateTime } = useFormat();

  if (!date) return null;

  const d = new Date(date);
  if (isNaN(d.getTime())) return null;

  return (
    <Typography
      variant={variant}
      color={color}
      noWrap={noWrap}
      component="span"
      sx={{ whiteSpace: "nowrap", ...sx }}
    >
      {formatDateTime(d)}
    </Typography>
  );
};
